import classnames from 'classnames';
import React, { FC } from 'react';
import { Loader } from '../index';
import styles from './FullHeightLoader.scss';
import { IOuter } from './FullHeightLoader.types';

export const FullHeightLoader: FC<IOuter> = ({ className, ...props }) => (
  <div className={classnames(styles.loader, className)} data-hook="full-height-loader">
    <Loader {...props} />
  </div>
);
